import { Route, Navigate } from "react-router-dom";
import { IdParamGuard } from "@/components/layout/IdParamGuard";
import { SettingsLayout } from "@/components/layout/SettingsLayout";
import { MemberRoute } from "@/components/auth";
import {
  MembersDashboard,
  RosterPage,
  RosterPrintPage,
  ProfilePage,
  MemberProfilePage,
  RosterProfileRedirect,
  MemberEventsPage,
  MemberEventDetailPage,
  EventFeedbackPage,
  GalleryPage,
  GalleriesIndexPage,
} from "@/components/members-section";
import {
  ProfileSettingsPage,
  GarageSettingsPage,
  AccountSettingsPage,
  NotificationSettingsPage,
} from "@/components/settings";
import { EventRegisterPage } from "@/pages";

export function memberRoutes() {
  return (
    <>
      <Route index element={<MembersDashboard />} />
      <Route path="/events" element={<MemberEventsPage />} />
      <Route
        path="/events/:id"
        element={
          <IdParamGuard>
            <MemberEventDetailPage />
          </IdParamGuard>
        }
      />
      <Route
        path="/events/:id/feedback"
        element={
          <IdParamGuard>
            <EventFeedbackPage />
          </IdParamGuard>
        }
      />
      <Route
        path="/events/:id/register"
        element={
          <IdParamGuard>
            <EventRegisterPage />
          </IdParamGuard>
        }
      />
      {/* Static segment first so /gallery never falls through to :galleryId. */}
      <Route path="/gallery" element={<GalleriesIndexPage />} />
      <Route
        path="/gallery/:galleryId"
        element={
          <IdParamGuard param="galleryId">
            <GalleryPage />
          </IdParamGuard>
        }
      />
      <Route
        path="/roster"
        element={
          <MemberRoute>
            <RosterPage />
          </MemberRoute>
        }
      />
      <Route
        path="/roster/print"
        element={
          <MemberRoute>
            <RosterPrintPage />
          </MemberRoute>
        }
      />
      <Route path="/profile" element={<ProfilePage />} />
      {/* Any authenticated user may hit /profile/:username; the API enforces
          that non-members can only view their own profile. */}
      <Route path="/profile/:username" element={<MemberProfilePage />} />
      {/* Legacy path — old links/emails redirect to /profile/:username */}
      <Route path="/roster/:username" element={<RosterProfileRedirect />} />
      <Route path="/settings" element={<SettingsLayout />}>
        <Route index element={<Navigate to="/settings/profile" replace />} />
        <Route path="profile" element={<ProfileSettingsPage />} />
        <Route path="garage" element={<GarageSettingsPage />} />
        <Route path="account" element={<AccountSettingsPage />} />
        <Route path="notifications" element={<NotificationSettingsPage />} />
      </Route>
    </>
  );
}
